import React from 'react'
import { 
    Button, 
    Row, 
    Input, 
    message,
} from 'antd'
import { firestore, firStorage } from '../../../service/firebase'
import './Settings.scss'

const { TextArea } = Input


export default class History extends React.Component {

    dataList = {}
    
    state = {
        showModal: false,
        uploadProgress: 0,
        uploadState: 0,
    }

    /*--------------------------------------------------------------*/
    /* Constructor */
    /*--------------------------------------------------------------*/

    constructor(props) {
        super(props)
        this.loadEvents()
    }


    /*--------------------------------------------------------------*/
    /* Load data */
    /*--------------------------------------------------------------*/

    loadEvents() {

        firestore.collection('Settings')
        .onSnapshot(snapshot => {
    
            snapshot.docChanges().forEach(change => {
    
                let data = change.doc.data()

                console.log(data, change.doc.id)
    
                if(change.type === 'added' || change.type === 'modified') {

                    this.dataList[change.doc.id] = data

                } else {

                    delete this.dataList[change.doc.id]

                }
            })
    
            this.setData()
        })
    
    }


    /*--------------------------------------------------------------*/
    /* Format functions */
    /*--------------------------------------------------------------*/

    setData() {
        let history = this.dataList['history']
        let link = this.dataList['link']

        let state = this.state
        state['history'] = history.link
        state['detail'] = history.content
        state['map'] = link.map
        state['weather'] = link.weather
        this.setState(state)
    }


    /*--------------------------------------------------------------*/
    /* Handle Functions */
    /*--------------------------------------------------------------*/

    updateHistory() {
        let history = this.dataList['history']
        let object = {
            banner: history.banner,
            content: this.state.detail,
            link: this.link(this.state.history),
        }

        let ref = firestore.collection('Settings').doc('history')
        ref.set(object)
    }
    
    updateMap() {
        let object = {
            map: this.link(this.state.map),
        }

        let ref = firestore.collection('Settings').doc('link')
        ref.update(object)
    }
    
    updateWeather() {
        let object = {
            weather: this.link(this.state.weather),
        }

        let ref = firestore.collection('Settings').doc('link')
        ref.update(object)
    }
    
    handleChange(key, value) {
        let state = this.state
        state[key] = value
        this.setState(state)
    }

    link(text) {
        if(text.substring(0, 4) === 'http') {
            return text
        } else {
            return 'http://' + text
        }
    }

    handleClose() {
        this.setState({showModal: false})
    }

    handleSelect(index) {
        let history = this.dataList['history']
        history['bannerSelected'] = index
        this.forceUpdate()
    }

    handleDeleteBanner(history) {
        history.banner.splice(history.bannerSelected)
        if(history.bannerSelected + 1 > history.banner.length) {
            history['bannerSelected'] = history.banner.length - 1
        }
        let ref = firestore.collection('Settings').doc('history')
        ref.update(history)
    }


    /*-----------------Upload Image-------------------*/

    handleUpload(input) {
        input.click()
    }

    onChangeFile(evt) {
        let orgName = evt.target.files[0].name
        let key = Date.now()
        let fileName = "history_" + key + "." + orgName.substring(orgName.length - 3)
        let path = '/logo/' + fileName
        this.uploadFile(evt.target.files[0], path)
    }
    
    uploadFile(file, path) {
        if(this.state.uploadState === 1) {
            return
        }

        this.setState({uploadState: 1})

        var uploadTask = firStorage.ref().child(path).put(file)
        uploadTask.on('state_changed', (snapshot) => {
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            this.setState({uploadProgress: progress})
            console.log('Upload is ' + progress + '% done')
        }, () => {
            this.setState({uploadState: 0})
            message.error("Failed on uploading image! Try again please!")
        }, () => {
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                console.log('File available at', downloadURL)
                
                let history = this.dataList['history']
                history.banner.push(downloadURL)
                let ref = firestore.collection('Settings').doc('history')
                ref.update(history)

                this.setState({
                    uploadState: 2,
                    logo: downloadURL
                })
            })
        })
    }


    /*--------------------------------------------------------------*/
    /* Render Functions */
    /*--------------------------------------------------------------*/
   
    render() {
        let history = this.dataList['history']
        if(history && !history.bannerSelected) history['bannerSelected'] = 0

        return (
            <div className="settings">

                <div className="history">
                    <div className="title">History</div>

                    <div style={{display: 'flex', height: 350}}>

                        <div style={{flex: 1, marginRight: 20}}>

                            <div style={{display: 'flex'}}>
                                <div style={{flex: 1, padding: 10, fontSize: 16, fontWeight: 'bold'}}>
                                { this.state.uploadState === 1 && 'Uploading.. ' + this.state.uploadProgress.toFixed(2) + '%' }
                                </div>
                                <Button style={{marginBottom: 10, marginTop: 10}} 
                                    type="primary" icon="plus" 
                                    onClick={() => this.handleUpload(this.bannerInput)}>
                                    History Banner
                                </Button>
                            </div>

                            <div style={{display: 'flex', height: 300}}>
                                <div style={{cursor: 'pointer', position: 'relative', width: 'calc(100% - 130px)'}}>
                                    <div className="btn-remove">
                                        <Button ghost type="danger" icon="delete" onClick={() => this.handleDeleteBanner(history)}></Button>
                                    </div>
                                    <div className="logo-img">
                                        { 
                                            history && history.banner ?
                                                <img src={history.banner[history.bannerSelected]} alt="IMG-LOGO" /> :
                                                'NO IMAGE'
                                        }
                                    </div>
                                </div>

                                <div className="banner-list">
                                {
                                    history && history.banner.map((banner, index) => {
                                        let clsName = index === history.bannerSelected ? 'selected' : ''
                                        return (
                                            <img className={clsName} 
                                                key={index} 
                                                src={banner} 
                                                onClick={() => this.handleSelect(index)}
                                                alt="BANNER" />
                                        )
                                    })
                                }
                                </div>
                            </div>
                                                
                            <input type="file" className="file-input" style={{display: 'none'}}
                                ref={input => this.bannerInput = input}
                                onChange={evt => this.onChangeFile(evt)}
                                accept="image/x-png,image/gif,image/jpeg" />

                        </div>
                        
                        <div style={{flex: 1, marginTop: 32}}>
                            <Row className="input-row">
                                <div className="input-label">Detail Link</div>
                                <Input value={this.state.history} onChange={evt => this.handleChange('history', evt.target.value)} />
                            </Row>

                            <Row className="input-row">
                                <div className="input-label">Content</div>
                                <TextArea autosize={{minRows: 3, maxRows: 9}} value={this.state.detail} onChange={evt => this.handleChange('detail', evt.target.value)} />
                            </Row>

                            <Row style={{textAlign: 'right', padding: 10}}>
                                <Button type="primary" icon="save" onClick={() => this.updateHistory()}>Update History</Button>
                            </Row>
                        </div>
                    </div>
                </div>

                <div className="other" style={{marginTop: 20}}>

                    <div style={{flex: 1, padding: 5}}>
                        <div className="title">Map Settings</div>
                        <Row className="input-row">
                            <Input value={this.state.map} onChange={evt => this.handleChange('map', evt.target.value)} />
                        </Row>

                        <Row style={{textAlign: 'right', padding: 10}}>
                            <Button type="primary" icon="save" onClick={() => this.updateMap()}>Update Map Link</Button>
                        </Row>
                    </div>

                    <div style={{flex: 1, padding: 5}}>
                        <div className="title">Weather Link Settings</div>
                        <Row className="input-row">
                            <Input value={this.state.weather} onChange={evt => this.handleChange('weather', evt.target.value)} />
                        </Row>

                        <Row style={{textAlign: 'right', padding: 10}}>
                            <Button type="primary" icon="save" onClick={() => this.updateWeather()}>Update Weather Link</Button>
                        </Row>
                    </div>
                </div>

            </div>
        )
    }
}
